import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import FileActions from "../../FileActions";
import { useOktaAuth } from "@okta/okta-react";
import toastMessages from "../../helpers/toastMessage";

function requestPayload(data: {
  userId: number;
  base64URL: string;
  fileName: string;
  token: string;
}): Promise<{ /* userId: number;  */ blobUrl: string }> {
  return new Promise(async (resolve, reject) => {
    try {
      const fileActions = new FileActions();
      let file: any = await fileActions.convertBase64ToImage(
        data.base64URL ?? "",
        data.fileName ?? ""
      );
      const filePath = await fileActions.uploadToAzure({
        type: "images/esignatures",
        file,
        token: data.token ?? "",
      });
      return resolve({
        // userId: data.userId,
        blobUrl: filePath,
      });
    } catch (error: any) {
      reject(new Error(error.message));
    }
  });
}

function useCreateSignature() {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["createSignature"],
    mutationFn: async (data: {
      userId: number;
      base64URL: string;
      fileName: string;
    }) => {
      return axiosInstance.post(
        `v1/esignature`,
        await requestPayload({
          ...data,
          token: authState?.accessToken?.accessToken ?? "",
        }),
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: (response) => {
      queryClient.refetchQueries({
        queryKey: ["physicianSignature"],
      });
      queryClient.refetchQueries({
        queryKey: ["profile"],
      });
      toastMessages.success(
        response?.data?.message ?? "E-signature created successfully"
      );
    },
    onError: (error: any) => {
      const msg = error?.response?.data?.message ?? error?.message;
      toastMessages.error(msg);
    },
  });
}

export default useCreateSignature;
